import { useEffect, useRef, useState } from 'react';
import { downloadBase64AsPDF } from '@ibk/shared-utils';
export function usePdfDownload(trigger, scopeKey) {
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const inFlight = useRef(false);
    const mounted = useRef(true);
    const activeRequest = useRef(null);
    const generation = useRef(0);
    useEffect(() => {
        mounted.current = true;
        setIsError(false);
        setIsLoading(false);
        inFlight.current = false;
        return () => {
            mounted.current = false;
            generation.current += 1;
            activeRequest.current?.abort();
        };
    }, [scopeKey]);
    async function download(params, filename) {
        if (inFlight.current || !Object.values(params).every(Boolean)) {
            return;
        }
        inFlight.current = true;
        setIsError(false);
        setIsLoading(true);
        const currentGeneration = generation.current;
        try {
            const request = trigger(params);
            activeRequest.current = request;
            const file = await request.unwrap();
            if (!mounted.current || currentGeneration !== generation.current)
                return;
            if (!file.base64) {
                throw new Error('Empty PDF');
            }
            downloadBase64AsPDF(file.base64, filename);
        }
        catch {
            if (mounted.current && currentGeneration === generation.current)
                setIsError(true);
        }
        finally {
            if (currentGeneration === generation.current) {
                inFlight.current = false;
                activeRequest.current = null;
                if (mounted.current)
                    setIsLoading(false);
            }
        }
    }
    return { download, isError, isLoading, clearError: () => setIsError(false) };
}
